const getValue = <T>(getter: () => T): T => getter();

export default getValue;
